<ion-header no-border>
  <ion-toolbar>

    <ion-buttons slot="start">
      <ion-button ion-button (click)="dismiss()" data-cy="editReview-toolbar-dismiss">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title class="color-dark" data-cy="editReview-toolbar-title">{{inputLabel}}</ion-title>

    <ion-buttons slot="end">
      <ion-button class="toolbarButton" color="primary" [disabled]="!inputData.reviewCount || !inputData.reviewStars" ion-button
        (click)="done()" data-cy="editReview-toolbar-save">
        Save
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content class="app-edit-review padding">

  <!--
  <h3 class="text-center color-dark">
     
  </h3>
  -->

  <div class="spacer-20"></div>

  <div class="inline-flex full-width">

    <ion-item class="reviewItem full-width">
      <ion-label class="dataItem" position="stacked" data-cy="editReview-form-reviewTitle">Review</ion-label>
      <ionic-rating-component style="margin-bottom: 5px;" activeIcon="star" defaultIcon="star-outline"
        activeColor="#FFBB54" defaultColor="#C1C8D7" rating="{{inputData.reviewStars}}"
        (ratingChanged)="logRatingChange($event)" fontSize="26px" data-cy="editReview-form-reviewInput">
      </ionic-rating-component>

    </ion-item>

    <ion-item class="full-width">
      <ion-label class="dataItem" position="stacked" data-cy="editReview-form-reviewCountTitle">Review Count</ion-label>
      <ion-input mode="ios" myNumberOnly type="number" pattern="[0-9]*" placeholder="Enter the review count"
        [(ngModel)]="inputData.reviewCount" data-cy="editReview-form-reviewCountInput">
      </ion-input>
    </ion-item>

  </div>

  <div class="spacer-15"></div>
  <ion-item>
    <ion-label class="dataItem" position="stacked" data-cy="editReview-form-reviewSnippetTitle">Review Snippet</ion-label>

    <!-- 
    <ion-input mode="ios" placeholder="Allow up to 255 characters" #reviewSnippet id="reviewSnippet"
      [(ngModel)]="inputData.reviewSnippet">
    </ion-input>
  -->

    <ion-textarea autocapitalize="sentences" #ionTextarea class="fullWidth" placeholder="Add text from a client review"
      type="text" [attr.rows]="rows" [(ngModel)]="inputData.reviewSnippet" (keydown)="limitText()"
      [maxlength]="limitNum" (ngModelChange)="inputData.reviewSnippet = $event" (keyup)="limitText()"
      data-cy="editReview-form-reviewSnippetInput">
    </ion-textarea>
  </ion-item>

  <p class="padding margin-left-10" [ngClass]="isDark ? 'count-dark' : 'count-danger'" text-center><b>{{countdown}}
      characters
      left.</b></p>

  <div class="spacer-15"></div>

</ion-content>